import { render, staticRenderFns } from "./JapaneseTable.vue?vue&type=template&id=7cd17d16&scoped=true&"
import script from "./JapaneseTable.vue?vue&type=script&lang=js&"
export * from "./JapaneseTable.vue?vue&type=script&lang=js&"
import style0 from "./JapaneseTable.vue?vue&type=style&index=0&id=7cd17d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd17d16",
  null
  
)

export default component.exports